import { useState } from 'react'
import Icons from '../../../assets/icons'
import DailySalesTabTableSkeleton from './skeletons/DailySalesTabTableSkeleton'
import LanguageTranslator from '../../../locals/LanguageTranslator'

const HEADERS = [
    { key: 'assortmentName', label: 'Category', group: null, align: 'left' },
    // Daily Sales
    { key: 'currDayQty', label: 'Qty', group: 'Daily Sales' },
    { key: 'currDaySelling', label: 'Net Sales', group: 'Daily Sales' },
    { key: 'currDayMrp', label: 'MRP Sales', group: 'Daily Sales' },
    { key: 'currDayAsp', label: 'ASP', group: 'Daily Sales' },
    { key: 'currDayMdPct', label: 'MD %', group: 'Daily Sales' },
    { key: 'prevDayQty', label: 'Prev Qty', group: 'Daily Sales' },
    { key: 'prevDaySelling', label: 'Prev Net Sales', group: 'Daily Sales' },
    { key: 'prevDayMrp', label: 'Prev MRP', group: 'Daily Sales' },
    { key: 'prevDayAsp', label: 'Prev ASP', group: 'Daily Sales' },
    { key: 'prevDayMdPct', label: 'Prev MD %', group: 'Daily Sales' },
    { key: 'dayGrowthPct', label: 'Growth %', group: 'Daily Sales' },
    // WTD
    { key: 'wtdQty', label: 'Qty', group: 'WTD' },
    { key: 'wtdSelling', label: 'Net Sales', group: 'WTD' },
    { key: 'wtdMrp', label: 'MRP Sales', group: 'WTD' },
    { key: 'wtdAsp', label: 'ASP', group: 'WTD' },
    { key: 'wtdMdPct', label: 'MD %', group: 'WTD' },
    { key: 'prevWtdQty', label: 'Prev Qty', group: 'WTD' },
    { key: 'prevWtdSelling', label: 'Prev Net Sales', group: 'WTD' },
    { key: 'prevWtdMrp', label: 'Prev MRP', group: 'WTD' },
    { key: 'prevWtdAsp', label: 'Prev ASP', group: 'WTD' },
    { key: 'prevWtdMdPct', label: 'Prev MD %', group: 'WTD' },
    { key: 'wtdGrowthPct', label: 'Growth %', group: 'WTD' },
    // MTD
    { key: 'mtdQty', label: 'Qty', group: 'MTD' },
    { key: 'mtdSelling', label: 'Net Sales', group: 'MTD' },
    { key: 'mtdMrp', label: 'MRP Sales', group: 'MTD' },
    { key: 'mtdAsp', label: 'ASP', group: 'MTD' },
    { key: 'mtdMdPct', label: 'MD %', group: 'MTD' },
    { key: 'prevMtdQty', label: 'Prev Qty', group: 'MTD' },
    { key: 'prevMtdSelling', label: 'Prev Net Sales', group: 'MTD' },
    { key: 'prevMtdMrp', label: 'Prev MRP', group: 'MTD' },
    { key: 'prevMtdAsp', label: 'Prev ASP', group: 'MTD' },
    { key: 'prevMtdMdPct', label: 'Prev MD %', group: 'MTD' },
    { key: 'mtdGrowthPct', label: 'Growth %', group: 'MTD' },
    // YTD
    { key: 'ytdQty', label: 'Qty', group: 'YTD' },
    { key: 'ytdSelling', label: 'Net Sales', group: 'YTD' },
    { key: 'ytdMrp', label: 'MRP Sales', group: 'YTD' },
    { key: 'ytdAsp', label: 'ASP', group: 'YTD' },
    { key: 'ytdMdPct', label: 'MD %', group: 'YTD' },
    { key: 'prevYtdQty', label: 'Prev Qty', group: 'YTD' },
    { key: 'prevYtdSelling', label: 'Prev Net Sales', group: 'YTD' },
    { key: 'prevYtdMrp', label: 'Prev MRP', group: 'YTD' },
    { key: 'prevYtdAsp', label: 'Prev ASP', group: 'YTD' },
    { key: 'prevYtdMdPct', label: 'Prev MD %', group: 'YTD' },
    { key: 'ytdGrowthPct', label: 'Growth %', group: 'YTD' },
];

const GROUPS = ['Daily Sales', 'WTD', 'MTD', 'YTD'];
const groupColSpan = (group) => HEADERS.filter(h => h.group === group).length;

const GROUP_BG = {
    'Daily Sales': '#f0fdfd',
    'WTD': '#f0f6ff',
    'MTD': '#f0fdfd',
    'YTD': '#f0f6ff',
};

const GROUP_BG_EXPAND = {
    'Daily Sales': '#d1f7f7',
    'WTD': '#d6e4ff',
    'MTD': '#d1f7f7',
    'YTD': '#d6e4ff',
}

const DailySalesTrackerCategoryLevel = (props) => {
    const { dashboardData, isLoading, getSiteWiseData, siteWiseData, siteWiseLoading, siteWiseError } = props;
    const [currentPage, setCurrentPage] = useState(1);
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (index, item) => {
        const newExpanded = !expandedRows[index];
        setExpandedRows(prev => ({ ...prev, [index]: newExpanded }));
        if (newExpanded && !siteWiseData?.[index]) {
            getSiteWiseData(item, index);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        props.getDashboardData({}, page);
    };

    const handleRefresh = () => {
        setExpandedRows({});
        setCurrentPage(1);
        props.getDashboardData({}, 1);
    };

    const rows = dashboardData?.resource || [];
    const maxPage = dashboardData?.maxPage || 1;
    const totalRecord = dashboardData?.totalRecord || 0;

    return (
        <div className='daily-sales-tracking'>
            {isLoading ? (<DailySalesTabTableSkeleton />) : (
                <div role="tabpanel" className="tab-pane fade p-lr-12" id="dailySalesTrackerCategoryLevel">
                    <div className="vendor-gen-table vgtbg-fcfdfe sticky-cat-col !h-full" style={{ minHeight: '550px' }}>
                        <div className="manage-table" style={{minHeight: 'calc(100vh - 219px)'}}>
                            <table className="table gen-main-table w-100">
                                <thead className="box-shadow-none">
                                    <tr className="vgt-header-top">
                                        <th className="vgtht-none fix-action-btn wid-40"></th>
                                        <th className="vgtht-none"></th>
                                        {GROUPS.map((group, i) => (
                                            <th
                                                key={group}
                                                colSpan={groupColSpan(group)}
                                                className={i % 2 === 0 ? 'vgtht-qty' : 'vgtht-value'}
                                            >
                                                <label>{group}</label>
                                            </th>
                                        ))}
                                    </tr>
                                    <tr>
                                        <th className="fix-action-btn wid-40">
                                            <ul className="rab-refresh">
                                                <li className="rab-rinner" onClick={handleRefresh}>
                                                    <Icons.RefreshIcon className='m-0' />
                                                    <LanguageTranslator tag="span" className="generic-tooltip">Refresh</LanguageTranslator>
                                                </li>
                                            </ul>
                                        </th>
                                        {HEADERS.map((h) => (
                                            <th key={h.key} style={h.group ? { backgroundColor: GROUP_BG[h.group] } : {}}><label>{h.label}</label></th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.length > 0 ? rows.map((item, index) => (
                                        <>
                                            <tr key={index}>
                                                <td className="fix-action-btn width40">
                                                    <ul className="table-item-list">
                                                        <li className="til-inner" onClick={() => toggleRow(index, item)} style={{ cursor: 'pointer' }}>
                                                            <svg width="19" height="19" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: expandedRows[index] ? 'rotate(90deg)' : 'none', transition: 'transform 0.2s ease' }}>
                                                                <g clipPath="url(#clip0_3375_6075)">
                                                                    <rect x="2.5" y="1.5" width="17" height="17" rx="4.5" fill="white" stroke="#C7D3DF" />
                                                                    <path d="M13.5996 10L9.59961 14L9.59961 6L13.5996 10Z" fill="#111D31" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_3375_6075">
                                                                        <rect width="21" height="21" fill="white" transform="translate(0 21) rotate(-90)" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </li>
                                                    </ul>
                                                </td>
                                                {HEADERS.map((h) => (
                                                    <td key={h.key} align={h.align === 'left' ? 'left' : 'right'} style={h.group ? { backgroundColor: GROUP_BG[h.group] } : {}}>
                                                        <label className={typeof item[h.key] === 'number' && item[h.key] < 0 ? '!text-red-500' : ''}>
                                                            {item[h.key] ?? '-'}
                                                        </label>
                                                    </td>
                                                ))}
                                            </tr>
                                            {expandedRows[index] && (
                                                siteWiseLoading?.[index] ? (
                                                    <tr key={`site-loading-${index}`}>
                                                        <td colSpan={HEADERS.length + 1} align="center">
                                                            <div className="flex items-center justify-center py-2 text-xs text-gray-400">Loading...</div>
                                                        </td>
                                                    </tr>
                                                ) : siteWiseError?.[index] ? (
                                                    <tr key={`site-error-${index}`}>
                                                        <td colSpan={HEADERS.length + 1} align="center">
                                                            <LanguageTranslator tag='label'>Failed to load site data!</LanguageTranslator>
                                                        </td>
                                                    </tr>
                                                ) : (siteWiseData?.[index] || []).length > 0 ? (
                                                    siteWiseData[index].map((siteItem, sIdx) => (
                                                        <tr key={`site-${index}-${sIdx}`} className="bg-blue-50/40">
                                                            <td></td>
                                                            {HEADERS.map((h) => (
                                                                <td key={h.key} align={h.align === 'left' ? 'left' : 'right'} style={h.group ? { backgroundColor: GROUP_BG_EXPAND[h.group] } : {}}>
                                                                    <label className={typeof siteItem[h.key] === 'number' && siteItem[h.key] < 0 ? '!text-red-500' : ''}>
                                                                        {h.key === 'assortmentName' ? (siteItem.siteName ?? '-') : (siteItem[h.key] ?? '-')}
                                                                    </label>
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr key={`site-empty-${index}`}>
                                                        <td colSpan={HEADERS.length + 1} align="center">
                                                            <LanguageTranslator tag='label'>No site data found!</LanguageTranslator>
                                                        </td>
                                                    </tr>
                                                )
                                            )}

                                        </>
                                    )) : (
                                        <tr>
                                            <td colSpan={HEADERS.length + 1} align="center">
                                                <LanguageTranslator tag='label'>No data found!</LanguageTranslator>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {totalRecord > 0 && (
                        <div className="flex items-center justify-between px-3 py-2 bg-white border-t text-[11px]">
                            <span className="text-gray-500">
                                Total: {totalRecord} records
                            </span>
                            <div className="flex items-center gap-2">
                                <button
                                    className="px-3 py-1 border rounded disabled:opacity-40"
                                    disabled={currentPage <= 1}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    <Icons.PrevIcon style={{ width: 12, height: 12 }} />
                                </button>
                                <span>Page {currentPage} of {maxPage}</span>
                                <button
                                    className="px-3 py-1 border rounded disabled:opacity-40"
                                    disabled={currentPage >= maxPage}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    <Icons.NextIcon style={{ width: 12, height: 12 }} />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DailySalesTrackerCategoryLevel;
